export default __webpack_public_path__ + "static/media/sertifikat_mst_new.3284ba2c.png";